import { ObstacleSettings } from "../ObstacleSettings";
import { eObstacleType } from "../ObstacleTypes";



export class MovingObsSettings extends ObstacleSettings {
    /**
     * (RO) Rychlost pohybu prekazky
     */
    get moveSpeed(): number { return this._moveSpeed; }
    private _moveSpeed: number;

    /**
     * (RO) Rychlost rotace na ose Z
     */
    get rotationSpeed(): number { return this._rotSpeed; }
    private _rotSpeed: number;

    /**
     * (RO) Velikost odstupu od leveho/praveho okraje radky
     */
    get hMargin(): number { return this._hMargin; }
    private _hMargin: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(version: number, hMargin: number, moveSpeed: number, rotSpeed: number) {
        super(eObstacleType.moving, version);

        this._hMargin = hMargin;
        this._moveSpeed = moveSpeed;
        this._rotSpeed = rotSpeed;
    }
}